<main class="content">
  <section class="two-column-section bg-white">
    <div class="container">
      <h2 class="section-title">Quem somos?</h2>
      <div class="two-column-wrapper">
        <div class="text-content">
          <p>
            <strong> Desde 2011, </strong> a Broadfactor é pioneira na
            antecipação digital de recebíveis. Nossos produtos e levar soluções
            de crédito para pequenas e médias empresas, proporcionamos inovação
            e simplificamos a busca por recursos financeiros de maneira prática,
            rápida e transparente.
          </p>
          <p>
            Acreditamos que os negócios são impulsionados pela colaboração e
            pelo uso de tecnologias que resolvem as principais dores de quem
            empreende no Brasil. É por isso que desenvolvemos soluções que
            facilitam o acesso ao crédito para milhares de empreendedores de
            forma ágil e segura.
          </p>
        </div>
        <div class="image-content">
          <img
            src="../../../assets/img/png/head 2.png"
            alt="Duas mulheres e um homem trabalhando de diferentes lugares"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <div class="two-column-wrapper">
        <div class="image-content">
          <img
            class="hidden-mobile"
            src="../../../assets/img/png/und4.png"
            alt="Ilustração - Nossa missão"
          />
        </div>
        <div class="text-content">
          <h2 class="section-title">Nossa missão</h2>
          <p>
            Nossa missão é equilibrar oferta e demanda de recebíveis com
            tecnologias inovadoras, como Factoring colaborativo, contas digitais
            e soluções customizadas de crédito.
            <strong>
              Queremos ser parceiros essenciais ao sucesso dos nossos
              clientes.</strong
            >
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <div class="two-column-wrapper">
        <div class="text-content">
          <h2 class="section-title">Nossa visão</h2>
          <p>
            Ser a bolsa de recebíveis brasileira,
            <strong> tornando-nos referência no mercado de crédito,</strong>
            reconhecidos por oferecer soluções inovadoras que impulsionam
            negócios e realizam sonhos.
          </p>
        </div>
        <div class="image-content">
          <img
            class="hidden-mobile"
            src="../../../assets/img/png/und6.png"
            alt="Ilustração - Nossa visão"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="values-section bg-white">
    <div class="container">
      <h2 class="section-title">Nossos valores</h2>
      <div class="values-container">
        <div class="values">
          <div class="space-value">
            <img src="../../../assets/img/png/Paixão.png" alt="Paixão" />
            <strong>Paixão</strong>
            <p>
              <strong> Somos apaixonados pelo que fazemos. </strong>Só quem é
              apaixonado de verdade entrega o melhor de si mesmo.
            </p>
          </div>
          <div class="space-value">
            <img
              src="../../../assets/img/png/Honestidade.png"
              alt="Honestidade"
            />
            <strong>Honestidade</strong>
            <p>
              Presente no DNA da Broadfactor, esse é o principal valor em nosso
              mercado. <strong>Transparência acima de tudo.</strong>
            </p>
          </div>
          <div class="space-value">
            <img src="../../../assets/img/png/Camada 3.png" alt="Confiança" />
            <strong>Confiança</strong>
            <p>
              <strong> Cumprimos o que lhe é prometido.</strong> Nosso serviço é
              de alta qualidade, com garantia e respeito de prazos.
            </p>
          </div>
          <div class="space-value">
            <img src="../../../assets/img/png/Camada 2.png" alt="Conexão" />
            <strong>Conexão</strong>
            <p>
              Desde 2011
              <strong> conectando compradores e vendedores </strong>de
              recebíveis para o negócio perfeito.
            </p>
          </div>
          <div class="space-value">
            <img
              src="../../../assets/img/png/excelência.png"
              alt="Excelência"
            />
            <strong>Excelência</strong>
            <p>
              Milhares de empreendedores confiam em nosso negócio para realizar
              seus sonhos, por isso <strong> não toleramos erros.</strong>
            </p>
          </div>
          <div class="space-value">
            <img
              src="../../../assets/img/png/expandaAtivo 1 2.png"
              alt="Inovação"
            />
            <strong>Inovação</strong>
            <p>
              Temos o compromisso de
              <strong> desenvolver soluções financeiras</strong> modernas,
              tecnológicas e que impactam.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <div class="two-column-wrapper mobile-reverse-column">
        <div class="image-content">
          <img
            src="../../../assets/img/png/imagen_emp-removebg-preview.png"
            alt="Ilustração - Colaboração"
          />
        </div>
        <div class="text-content">
          <h2 class="section-title">Somos apaixonados por colaboração!</h2>
          <p>
            Nossos Broaders mantêm uma rotina equilibrada e produtiva.
            Acreditamos em um futuro próspero, conectando empresas a
            investidores e oferecendo a tecnologia necessário para o futuro
            próspero.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-white">
    <div class="container">
      <h2 class="section-title">Como podemos ajudar você?</h2>
      <div class="two-column-wrapper">
        <div class="text-content">
          <p>
            Nossos produtos oferecem crédito rápido e seguro, facilitam o fluxo
            de caixa e fornecem soluções de gestão financeira para apoiar o
            crescimento do seu negócio.
          </p>
        </div>
        <div class="image-content">
          <img
            src="../../../assets/img/png/Venha expandir com a broadfactor 1.png"
            alt="Ilustração - Colaboração"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="two-column-section bg-gray">
    <div class="container">
      <div class="two-column-wrapper mobile-reverse-column">
        <div class="image-content">
          <img
            src="../../../assets/img/png/PARC.png"
            alt="Ilustração - Colaboração"
          />
        </div>
        <div class="text-content">
          <h2 class="section-title">Junte-se a nós!</h2>
          <p>
            A Broadfactor <strong>a parceira estratégica</strong> que impulsiona
            o seu negócio, transformando desafios em conquistas e sonhos em
            realidade.
          </p>
          <button
            mat-flat-button
            class="find-out-more-button"
            (click)="redirectToWhatsApp()"
          >
            Saiba mais
          </button>
        </div>
      </div>
    </div>
  </section>
</main>
